
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom/merchants-ecology",
      function () {
        return require("private-next-pages/newsroom/merchants-ecology.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsroom/merchants-ecology"])
      });
    }
  